<template>
  <div class="wrap">
    <div id="primary" class="content-area">
      <main class="site-main">
        <article class="page type-page status-publish hentry">
          <div class="entry-content">
            <h1>{{ $t('contact.title') }}</h1>
          </div>
          <p>
            <img class="size-full aligncenter" src="images/contact.jpg">
          </p>
 
          <p>
            <label>
              {{ $t('contact.items[0].name.name') }}：
              <span>{{ $t('contact.items[0].name.value') }}</span>
            </label>
          </p>
          <p>
            <label>
              {{ $t('contact.items[0].changer.name') }}：
              <span>{{ $t('contact.items[0].changer.value') }}</span>
            </label>
          </p>
          <p>
            <label>
              {{ $t('contact.items[0].tel.name') }}：
              <span>{{ $t('contact.items[0].tel.value') }}</span>
            </label>
          </p>
          <p>
            <label>
              {{ $t('contact.items[0].email.name') }}：
              <span>{{ $t('contact.items[0].email.value') }}</span>
            </label>
          </p>
  <hr/>
           <p  v-if="showMid">
            <label>
              {{ $t('contact.items[1].name.name') }}：
              <span>{{ $t('contact.items[1].name.value') }}</span>
            </label>
          </p>
          <p  v-if="showMid">
            <label>
              {{ $t('contact.items[1].changer.name') }}：
              <span>{{ $t('contact.items[1].changer.value') }}</span>
            </label>
          </p>
          <p  v-if="showMid">
            <label>
              {{ $t('contact.items[1].tel.name') }}：
              <span>{{ $t('contact.items[1].tel.value') }}</span>
            </label>
          </p>
          <p  v-if="showMid">
            <label>
              {{ $t('contact.items[1].email.name') }}：
              <span>{{ $t('contact.items[1].email.value') }}</span>
            </label>
          </p>
  <hr  v-if="showMid"/>
          <p>
            <label>
              {{ $t('contact.address[0].addrName') }}
            </label>
          </p>
          <p>
            <label>
           
              <span>{{ $t('contact.address[0].companyName') }}</span>
            </label>
          </p>
          <p>
            <label>
           
              <span>{{ $t('contact.address[0].addr') }}</span>
            </label>
          </p>
 <hr/>
          <p>
            <label>
              {{ $t('contact.address[1].addrName') }}
            </label>
          </p>
          <p>
            <label>
           
              <span>{{ $t('contact.address[1].companyName') }}</span>
            </label>
          </p>
          <p>
            <label>
           
              <span>{{ $t('contact.address[1].addr') }}</span>
            </label>
          </p>
  <hr/>
          <p>
            <label>
              {{ $t('contact.address[2].addrName') }}
            </label>
          </p>
          <p>
            <label>
           
              <span>{{ $t('contact.address[2].companyName') }}</span>
            </label>
          </p>
          <p>
            <label>
           
              <span>{{ $t('contact.address[2].addr') }}</span>
            </label>
          </p>
        </article>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  data(){
   return { showMid:true}
  },
  mounted() {
    
      if(window.location.href.indexOf('mltcloud.com')!=-1){ 
        this.showMid=  false;
      }else{
        this.showMid= true;
      }
     
    document.body.className = "page-template-default page page-one-column colors-light";
  },
}
</script>

<style lang="stylus" scoped>
label span {
  font-weight: normal;
}
</style>

